import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@sainsburys-tech/fable'
import { IphoneX } from '@sainsburys-tech/icons'
import { BuyOnAppButton } from './BuyOnAppButton'

export const BuyOnAppContainer = ({ className, link }) => {
  return (
    <Box
      as='div'
      id='buy-on-app-container'
      border={{ radius: 'lg', size: 'sm' }}
      className={`buy-on-app-container ${className || ''}`}
      padding={{ sm: 'sm', md: 'sm', lg: 'sm' }}
    >
      <div className='buy-on-app-container-title'>
        <IphoneX width={24} height={24} className='buy-on-app-container-icon' />
        App exclusive product
      </div>
      Download the Argos app for exclusive products, discounts and price drop notifications
      <BuyOnAppButton link={link} />
    </Box>
  )
}

BuyOnAppContainer.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string.isRequired
}
